import React, { useEffect } from "react";
import { X, TerminalSquare } from "lucide-react";
import RemediationOutputField from "./RemediationOutputField";

function RemediationOutputPopup({
    previousOutput,
    previousStartTime,
    remediateOutput,
    remediateStartTime,
    output,
    startTime,
    closePopup
}) {

    useEffect(() => {
        document.body.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                closePopup();
            }
        };

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [closePopup]);

    return (
        <div className="oct-remediation-output-modal" role="dialog" aria-modal="true" aria-labelledby="oct-remediation-output-title">
            <div className="oct-remediation-output-modal__backdrop" onClick={closePopup} />

            <div className="oct-remediation-output-modal__dialog" onClick={(event) => event.stopPropagation()}>
                <div className="oct-remediation-output-modal__header">
                    <div className="oct-remediation-output-modal__header-glow" />

                    <div className="oct-remediation-output-modal__title-wrap">
                        <div className="oct-remediation-output-modal__title-icon">
                            <TerminalSquare size={18} />
                        </div>

                        <div>
                            <h2 id="oct-remediation-output-title" className="oct-remediation-output-modal__title">
                                Remediated Rule Outputs
                            </h2>
                            <p className="oct-remediation-output-modal__subtitle">
                                Review the output before, during, and after remediation.
                            </p>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="oct-remediation-output-modal__close"
                        onClick={closePopup}
                        aria-label="Close remediation output popup"
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-remediation-output-modal__body">
                    <RemediationOutputField output={previousOutput} startTime={previousStartTime} title="Previous Output" />
                    <RemediationOutputField output={remediateOutput} startTime={remediateStartTime} title="Remediation Output" />
                    <RemediationOutputField output={output} startTime={startTime} title="Later Output" />
                </div>

                <div className="oct-remediation-output-modal__footer">
                    <button
                        type="button"
                        className="btn oct-remediation-output-modal__btn"
                        onClick={closePopup}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RemediationOutputPopup;
